import { createContext } from 'react';

/**
 * Note: Still used by components generated by old versions of Framer
 *
 * @deprecated
 */
const DeprecatedLayoutGroupContext = createContext(null);

export { DeprecatedLayoutGroupContext };
